<span *ngFor='let message of messagesService.messages; index as i'>
<div *ngIf="message" [class]="'alert ' + getClass(message) + ' alert-dismissible fade show'" role="alert">
    <strong *ngIf="message.lead">{{ message.lead }}</strong> {{ message.text }}
  <button (click)="messagesService.remove(i)" aria-label="Close" class="close" data-dismiss="alert" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
</span>
